import supportAccess from './UserSupportAccess'
import {UserResource} from "../Api/User";

const badges = {
    namespaced: true,
    state: {
        badges: {},
    },
    mutations: {
        set(state, data) {
            state.badges = data
        }
    },
    getters: {
        inboxCountMine(state) {
            return state.badges.inbox ? state.badges.inbox.mine : 0
        },
        inboxCountWaiting(state) {
            return state.badges.inbox ? state.badges.inbox.waiting : 0
        },
        inboxCountFollowUp(state) {
            return state.badges.inbox ? state.badges.inbox.follow_up : 0
        },
        inboxCountAi(state) {
            return state.badges.inbox ? state.badges.inbox.ai : 0
        },
    },
    actions: {
        update(context) {
            return new Promise((resolve, reject) => {
                UserResource.status().then(response => {
                    context.commit('set', response.data.badges)
                    resolve(response.data.badges)
                }).catch(e => handleApiError(e, reject))
            })
        }
    }
}

const User = {
    namespaced: true,
    modules: { badges, supportAccess },
    state: {
        current: null,
        authorisations: [],
    },   
    mutations: {
        set(state, user) {
            state.current = user;
        },
        setAuthorisations(state, authorisations) {
            state.authorisations = authorisations;
        }
    },
    getters: {
        can: (state) => (name) => {
            if (state.authorisations[name]) {
                return state.authorisations[name];
            }

            return false;
        }
    }
}

export default User